// import React, { useEffect, useState } from "react";
// import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import ArrowOutwardOutlinedIcon from "@mui/icons-material/ArrowOutwardOutlined";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import Credentials, { transactionFrom } from "../Common/Credentials.js";
// import dashboardIcon from "../images/Icons/dashboard.png"
// import transactionsIcon from "../images/Icons/transaction.png"
// import reportsIcon from "../images/Icons/annual-report.png"
// import { Backdrop } from "@mui/material";
// import "../NewUI/NewMenu.css";

// const AssetMenu = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Assets")
//   }, [])

//   return (
//     <div>
//       <Backdrop
//         sx={{
//           color: "#fff",
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//         open={transactionFrom === null}
//       >
//         <div className="menu-backdrop-content">
//           <div className="d-flex justify-content-center">
//             <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
//           </div>
//           <div className="d-flex justify-content-center">
//             <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
//           </div>
//         </div>
//       </Backdrop>
      
//       <Header />
//       <Menu />
      
//       <section className="content-wrapper">
//         <div className="menu-container tw-mx-2">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <nav className="menu-breadcrumb">
//                 <Link
//                   to="/assetmanagement"
//                   className="menu-breadcrumb-link"
//                   onMouseEnter={() => setHovered('home')}
//                   onMouseLeave={() => setHovered(null)}
//                 >
//                   Home
//                 </Link>
//                 <span>/</span>
//                 <span className="menu-breadcrumb-active">
//                   Asset Management
//                 </span>
//               </nav>

//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>
                
//                 <div className="menu-sections-container">
//                   {(screens.includes("Assets") || screens.includes("Maintenance") || screens.includes("Production Usage") || screens.includes("Transportation")) ? (
//                     <div className="menu-section menu-transactions-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon" width="20" src={transactionsIcon} />
//                         <span className="menu-section-title-text">Transactions</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         {screens.includes("Assets") ?
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/asset" }}
//                               state={{ message: "", sold: false, rent: false, active: true, type: 'Rental', stype: 'Sales' }}
//                             >
//                               Assets
//                             </Link>
//                           </li> : ""}
//                         {screens.includes("Maintenance") ?
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/assetmaintenance" }}
//                               state={{ message: "" }}
//                             >
//                               Maintenance
//                             </Link>
//                           </li>
//                           : ""}
//                         {screens.includes("Production Usage") ?
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/productionusage" }}
//                               state={{ message: "" }}
//                             >
//                               Production Usage
//                             </Link>
//                           </li> : ""}
//                         {screens.includes("Transportation") ?
//                           <li>
//                             <Link
//                               className="menu-item-link"
//                               to={{ pathname: "/transportation" }}
//                               state={{ message: "" }}
//                             >
//                               Transportation
//                             </Link>
//                           </li> : ""}
//                       </ul>
//                     </div>
//                   ) : ""}

//                   <div className="menu-section">
//                     <span className="menu-section-title">
//                       <img className="menu-section-icon-reports" src={reportsIcon} />
//                       <span className="menu-section-title-text">Reports</span>
//                     </span>
//                     <ul className="menu-items-list">
//                       <li>
//                         <Link
//                           className="menu-item-link"
//                           to={{ pathname: "/transportationreport" }}
//                           state={{ message: "" }}
//                         >
//                           Transportation Report
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(AssetMenu);




// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import withRouter from "../withRouter.js";
// import Footer from "../Component/Footer.js";
// import Menu from "../Component/Menu.js";
// import Header from "../Component/Header.js";
// import { screens } from "../Common/Products.js";
// import Credentials from "../Common/Credentials.js";
// import mastersIcom from "../images/Icons/generic.png"
// import dashboardIcon from "../images/Icons/dashboard.png"
// import "../NewUI/NewMenu.css"; // Import the shared CSS file
// import Breadcrumb from "../NewUI/NewComponents/Breadcrumb.jsx";

// const MastersMenu = () => {
//   const [hovered, setHovered] = useState(null);

//   useEffect(() => {
//     Credentials.setSelectedMenu("Masters")
//   }, [])

//   return (
//     <div>
//       <Header />
//       <Menu />
      
//       <section className="content-wrapper">
//         <div className="menu-container">
//           <div className="menu-card">
//             <div className="menu-header">
//               {/* Modern Breadcrumb Navigation */}
//               <Breadcrumb breadcrumbs={[{name:"Home",path:"/dashboard"},{name:"Masters",path:null}]}/>
//               <div className="h-max border-slate-300 bg-white  p-4 rounded-lg menu-content">
//                 <ul className="menu-nav-list">
//                   <li className="menu-nav-item">
//                     <Link
//                       to={{ pathname: "/index" }}
//                       state={{ message: "" }}
//                       className="menu-nav-link"
//                     >
//                       <img className="menu-nav-icon" width="25" src={dashboardIcon} />
//                       <div className="mt-1">Dashboard</div>
//                     </Link>
//                   </li>
//                 </ul>
                
//                 <div className="menu-sections-container">
//                   {screens.includes("Admin Masters") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-masters" src={mastersIcom} />
//                         <span className="menu-section-title-text">Admin Masters</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/users" }}
//                             state={{ message: "" }}
//                           >
//                             Users
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/roles" }}
//                             state={{ message: "" }}
//                           >
//                             Roles
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/usercustomers" }}
//                             state={{ message: "" }}
//                           >
//                             User-Customers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/salescaltable" }}
//                             state={{ message: "" }}
//                           >
//                             Sales Calculation
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/customerterms" }}
//                             state={{ message: "" }}
//                           >
//                             Customer Terms
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/bank" }}
//                             state={{ message: "" }}
//                           >
//                             Banks
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}

//                   {screens.includes("General Masters") ? (
//                     <div className="menu-section">
//                       <span className="menu-section-title">
//                         <img className="menu-section-icon-masters" src={mastersIcom} />
//                         <span className="menu-section-title-text">General Masters</span>
//                       </span>
//                       <ul className="menu-items-list">
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/employees" }}
//                             state={{ message: "", employeetype: 0 }}
//                           >
//                             Employees
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/customers" }}
//                             state={{ message: "" }}
//                           >
//                             Customers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/suppliers" }}
//                             state={{ message: "" }}
//                           >
//                             Suppliers
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/agents" }}
//                             state={{ message: "" }}
//                           >
//                             Agents
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/assigntype" }}
//                             state={{ message: "" }}
//                           >
//                             Assign Type
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/warehouse" }}
//                             state={{ message: "" }}
//                           >
//                             Org Unit
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/department" }}
//                             state={{ message: "" }}
//                           >
//                             Department
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/workcenter" }}
//                             state={{ message: "" }}
//                           >
//                             Workcenter/Production Unit
//                           </Link>
//                         </li>
//                         <li>
//                           <Link
//                             className="menu-item-link"
//                             to={{ pathname: "/transporter" }}
//                             state={{ message: "" }}
//                           >
//                             Transporter
//                           </Link>
//                         </li>
//                       </ul>
//                     </div>
//                   ) : ""}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//   );
// };

// export default withRouter(MastersMenu);







import React from 'react';
import { 
  FolderLock, 
  ArrowRightLeft, 
  FileText,
  ChevronRight,
  Blocks,
  Ruler,
  Tag,
  Palette,
  Layers,
  ShoppingBag,
  Wrench,
  DollarSign,
  Boxes,
  ClipboardCopy,
  AlertTriangle,
  FolderSync,
  TrendingDown,
  Warehouse,
  Users,
  Building2,
  Truck,
  Grid,
  Handshake,
  Calculator,
  ShieldUser,
  Activity,
  Box
} from 'lucide-react';
import path from 'path-browserify';
import withRouter from '../withRouter';
import Footer from '../Component/Footer';
import { Backdrop } from '@mui/material';
import Header from '../Component/Header';
import Menu from '../Component/Menu';
import { theme, transactionFrom } from '../Common/Credentials';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from '../NewUI/NewComponents/Breadcrumb';
import { use } from 'react';
import Layout from '../Component/Layout';

const AssetsMenu = () => {
  const navigate = useNavigate();
  // Structure mapping matching the image exactly
  const newsections = [

     {
      title: 'Transactions',
      subtitle: 'Fixed capital equipment schedules',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' :  'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'assets', label: 'Company Assets', desc: 'Active machinery, plant floors and vehicles', icon: Box, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' :  'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-707', path: '/asset', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' },
        { id: 'maintenance', label: 'Maintenance Log', desc: 'Preventative spare parts replacement, schedules', icon: Wrench, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-rose-50 hover:tw-bg-rose-100 tw-text-rose-700', path: '/assetmaintenance', brandColor: theme === "classic" ? '#4d4d4d' : '#F43F5E' },
        { id: 'prod_usage', label: 'Production Usage hours', desc: 'Heavy equipment hour meters and fuel tracking', icon: Activity, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-amber-50 hover:tw-bg-amber-100 tw-text-amber-707', path: '/productionusage', brandColor: theme === "classic" ? '#4d4d4d' : '#F59E0B' },
        { id: 'transportation', label: 'Logistics/Transportation Mobilization', desc: 'Site-to-site machinery transit clearances', icon: Truck, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-blue-50 hover:tw-bg-blue-100 tw-text-blue-700', path: '/transportation', brandColor: theme === "classic" ? '#4d4d4d' : '#3B82F6' }
      ]
    },
    {
      title: 'Reports',
      subtitle: 'Mobility & depreciation logs',
      icon: FolderLock,
      iconColor: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-100 tw-text-indigo-600 tw-border-indigo-200',
      items: [
        { id: 'rpt_transp', label: 'Transportation fuel summary', desc: 'Vehicular route efficiency metrics sheets', icon: FileText, brandStyle: theme === "classic" ? 'tw-bg-[#f8f0e7] tw-text-[#4d4d4d]' : 'tw-bg-indigo-50 hover:tw-bg-indigo-100 tw-text-indigo-707', path: '/transportationreport', brandColor: theme === "classic" ? '#4d4d4d' : '#6366F1' }
      ]
    }
  ]


  const onSelectItem = (path) => {
    if(path==="/asset"){
      navigate(path,{ state: { message: "", sold: false, rent: false, active: true, type: 'Rental', stype: 'Sales' } });
    }else{
    navigate(path,{ state: { message: "" } });
    }
  }

  return (
        <div>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={transactionFrom === null}
      >
        <div className="menu-backdrop-content">
          <div className="d-flex justify-content-center">
            <i className="menu-backdrop-text">Please set transaction start date in order to continue.</i>
          </div>
          <div className="d-flex justify-content-center">
            <Link to="/settings" className="btn btn-sm menu-backdrop-button">Set</Link>
          </div>
        </div>
      </Backdrop>
      
     <Layout menu={"assetmanagement"}>
         <div className="menu-container tw-ml-4 tw-mr-2" >
          <div
  id="dashboard-content-area"
  className="tw-flex-1  tw-overflow-y-auto tw-bg-transparent tw-pb-4"
>
  {/* Upper Hero Grid */}
  <div
    id="hero-welcome-banner"
    className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-items-center tw-bg-white tw-rounded-3xl tw-px-8 tw-py-2 tw-border tw-border-slate-200/80 tw-shadow-[0_12px_40px_rgba(0,0,0,0.02)] tw-mb-4 tw-relative tw-overflow-hidden"
  >
    {/* Background Blur Shapes */}
    <div className="tw-absolute tw-top-0 tw-right-0 tw-w-96 tw-h-96 tw-bg-blue-50/40 tw-rounded-full tw-blur-3xl -tw-z-10 tw-translate-x-12 -tw-translate-y-12"></div>

    <div className="tw-absolute tw-bottom-0 tw-left-0 tw-w-64 tw-h-64 tw-bg-indigo-50/30 tw-rounded-full tw-blur-3xl -tw-z-10 -tw-translate-x-12 tw-translate-y-12"></div>

    {/* Left Content */}
    <div className="md:tw-col-span-2 tw-text-left tw-space-y-2">
      <Breadcrumb breadcrumbs={[{name:"Home",path:"/index"},{name:"Assets Management",path:null}]}/>
      <h1 className="tw-text-4xl tw-font-extrabold tw-tracking-tight tw-text-slate-900 tw-pt-1">
        Assets Management
      </h1>

      <p className="tw-text-slate-500 tw-font-medium tw-text-[10px] md:tw-text-xs tw-max-w-lg">
        Track registered factory buildings, profile machinery downtime maintenance schedules histories, monitor heavy vehicle fuel usages, and mobilize assets.
      </p>
    </div>

     {/* 3D SVG Security Badging Illustration */}
        <div className="tw-flex tw-justify-center md:tw-justify-end mt-0 tw-relative tw-group">
          {/* <div className="tw-w-40 tw-h-40 tw-relative tw-flex tw-items-center tw-justify-center tw-animate-bounce tw-duration-1000 tw-ease-in-out" style={{ animationDuration: '4.5s' }}> */}
          <div className="tw-w-32 tw-h-32 tw-relative tw-flex tw-items-center tw-justify-center">

            <div className="tw-absolute tw-bottom-4 tw-w-28 tw-h-3 tw-bg-slate-300/30 tw-rounded-full tw-blur-md"></div>
            
           <svg viewBox="0 0 200 200" className="tw-w-32 tw-h-32 tw-drop-shadow-xl tw-select-none tw-pointer-events-none">
              <defs>
                <linearGradient id="armBody" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#FB923C" />
                  <stop offset="100%" stopColor="#EA580C" />
                </linearGradient>
              </defs>
              <rect x="25" y="25" width="150" height="150" rx="36" fill="#F1F5F9" />
              {/* Foundation stand */}
              <rect x="65" y="130" width="70" height="15" fill="#334155" rx="3" />
              {/* Hydraulic base rotation tower */}
              <circle cx="100" cy="115" r="16" fill="#475569" />
              {/* Articulated joint orange arms with gears */}
              <rect x="94" y="65" width="12" height="50" fill="url(#armBody)" rx="4" transform="rotate(-25, 100, 115)" />
              <circle cx="80" cy="72" r="10" fill="#1E293B" />
              <rect x="74" y="30" width="12" height="45" fill="url(#armBody)" rx="4" transform="rotate(35, 80, 72)" />
              {/* Magnetic gripping load block */}
              <rect x="95" y="18" width="24" height="14" fill="#1E293B" rx="1" transform="rotate(35, 80, 72)" />
              {/* Glow particle laser pulse */}
              <circle cx="118" cy="22" r="4" fill="#10B981" className="animate-ping" style={{ animationDuration: '1.2s' }} />
            </svg>
          </div>
        </div>
  </div>

  {/* Main Grid */}
  <div
    id="erp-columns-grid"
    className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4"
  >


    {/* Menus */}
        {newsections.map((section) => {
          // const Icon = section.icon;
          return(
     <div
            key={section.title}
      id="section-col-masters"
      className="tw-bg-white tw-rounded-3xl tw-border tw-border-slate-200/80 tw-p-6 tw-shadow-[0_8px_30px_rgba(0,0,0,0.015)] tw-text-left tw-flex tw-flex-col hover:tw-shadow-lg tw-transition-shadow tw-duration-300"
    >
      <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6 tw-pb-4 tw-border-b tw-border-slate-100">
        <div
          className={`tw-w-12 tw-h-12 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-border ${section.iconColor}`}
        >
          <FolderLock size={22} />
          {/* <Icon size={22} color={section.iconColor} /> */}
        </div>

        <div>
          <h2 className="tw-text-lg tw-font-extrabold tw-text-slate-800">
            {section.title}
          </h2>

          <p className="tw-text-xs tw-text-slate-400 tw-font-medium tw-my-0">
            {section.subtitle}
          </p>
        </div>
      </div>

      <div className="tw-space-y-3 tw-flex-1">
        {section.items.map((item) => {
          const Icon = item.icon;

          return (
            <button
              id={`subsection-btn-${item.id}`}
              key={item.id}
              onClick={() => onSelectItem(item.path)}
              className="tw-w-full tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-2 tw-rounded-2xl tw-border tw-border-slate-100 tw-bg-white hover:tw-bg-slate-50 hover:tw-border-slate-300/60 hover:tw-shadow-sm tw-transition-all tw-group tw-duration-200 tw-cursor-pointer tw-text-left"
            >
              <div className="tw-flex tw-items-center tw-gap-3.5">
                <div
                  className={`tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center ${item.brandStyle} tw-shrink-0`}
                >
                  <Icon size={16} color={item.brandColor} />
                </div>

                <div>
                  <h4 className="tw-text-sm tw-font-bold tw-text-slate-700 group-hover:tw-text-blue-600 tw-transition-colors">
                    {item.label}
                  </h4>

                  {/* <p className="tw-text-[10px] tw-text-slate-400 tw-font-medium tw-mt-0.5 tw-mb-0">
                    {item.desc}
                  </p> */}
                </div>
              </div>

              <ChevronRight
                size={16}
                className="tw-text-slate-300 group-hover:tw-text-blue-500 group-hover:tw-translate-x-0.5 tw-transition-all"
              />
            </button>
          );
        })}
      </div>
    </div>)}
  )}
  </div>

</div>
          </div>
          </Layout>
      </div>
  );
}
export default withRouter(AssetsMenu);